export default __webpack_public_path__ + "static/media/proclamation10.e70b7cd9.jpg";